import React from 'react';
import { DGPT_LOGO_SRC } from '../../data/dgpt';
import { cn } from '../../src/lib/utils';
type DgptLogoProps = {
  className?: string;
  showByline?: boolean;
};

/** Official DiligenceGPT™ logo image with optional StartupFuel byline. */
export function DgptLogo({
  className,
  showByline = true
}: DgptLogoProps) {
  return <span className={cn('inline-flex flex-col leading-none', className)} data-id="element-70" data-mp="154v9zqu4ffxf">
      <img src={DGPT_LOGO_SRC} alt="DiligenceGPT" width={1000} height={200} decoding="async" className="h-7 w-auto object-contain sm:h-8" data-id="element-71" data-mp="1073gwthqpnrn" />
      {showByline ? <span className="mt-1 pl-[18%] text-[9px] uppercase tracking-[0.16em] text-text-tertiary" data-id="element-72" data-mp="rfbcp0jb7avi">
          by StartupFuel
        </span> : null}
    </span>;
}